import { usd, fecha } from "./util";
import { pct } from "./graf";

const colorPag = (dias) => (dias > 60 ? "#E07A62" : dias > 30 ? "#D2A23A" : "#2E9A5E");

const Pagares = ({ d }) => {
  const p = d.pagares || {}, items = p.items || [];
  const n = { v: items.filter((x) => (x.dias ?? 0) < 31).length, a: items.filter((x) => x.dias > 30 && x.dias <= 60).length, r: items.filter((x) => x.dias > 60).length };
  const viejo = Math.max(0, ...items.map((x) => x.dias || 0));
  return (
    <div className="rs-card rg-card rg-sec" data-testid="resumen-f3-pagares">
      <h4>Pagarés pendientes de firma</h4>
      {!items.length ? <p className="rs-vacio">No tiene pagarés pendientes.</p> : (
        <>
          <div className="g">{p.cantidad} <small>· {usd(p.total)}</small></div>
          <div className="rg-cuadros">{items.map((x, i) => <i key={i} style={{ background: colorPag(x.dias), animationDelay: `${i * 35}ms` }} title={`${usd(x.monto)} · emitido ${fecha(x.fecha_emision)} · ${x.dias ?? "—"} días sin firma`} data-testid="resumen-pagare-cuadro" />)}</div>
          <div className="rg-tl-ley"><i style={{ background: "#2E9A5E" }} />{n.v} &lt;31 d <i style={{ background: "#D2A23A" }} />{n.a} 31–60 d <i style={{ background: "#E07A62" }} />{n.r} &gt;60 d</div>
          <i className="rg-barra"><u style={{ width: `${Math.min(100, (viejo / 60) * 100)}%`, background: colorPag(viejo) }} /></i>
          <em className="rg-em">el más antiguo: {viejo} días (límite 60)</em>
        </>
      )}
    </div>
  );
};

const Cobranza = ({ d }) => {
  const pg = d.pagos || {}, cob = pg.cobrado_mes || 0;
  const grande = (d.vencimientos || []).filter((v) => v.fecha && v.dias <= 0 && -v.dias <= 15 && v.monto >= Math.max(1000, d.saldo * 0.1)).sort((a, b) => b.monto - a.monto)[0];
  return (
    <div className="rs-card rg-card rg-sec" data-testid="resumen-f3-cobranza">
      <h4>Cobranza del mes</h4>
      {cob ? <><div className="g" style={{ color: "#7DBE8C" }}>{usd(cob)}</div><div className="d">cobrado en {pg.mes} · último cobro {fecha(pg.ultimo_cobro)}</div></>
        : <><div className="g" style={{ color: "#A9B8A5" }}>Sin cobros este mes</div>{pg.ultimo_cobro && <div className="d">último cobro {fecha(pg.ultimo_cobro)}</div>}</>}
      {grande && <p className="rg-aviso" data-testid="resumen-aviso-pago">El {fecha(grande.fecha).slice(0, 5)} vencen {usd(grande.monto)}: conviene confirmar el pago</p>}
    </div>
  );
};

const Respaldo = ({ d }) => {
  const g = d.garantia || {}, l = d.linea || {}, pgn = d.pagares?.cantidad || 0;
  const tieneReal = Boolean(g.reales || g.carga);
  const p = l.pct ?? pct(l.usado || 0, l.total || 0);
  const alertas = [];
  if (p >= 90) alertas.push(`Usa el ${p.toLocaleString("es-PY", { maximumFractionDigits: 1 })}% de la línea`);
  if (!tieneReal && !g.items?.length) alertas.push("sin garantía real");
  if (pgn) alertas.push(`con ${pgn} pagaré${pgn > 1 ? "s" : ""} por firmar`);
  return (
    <div className="rs-card rg-card rg-sec" data-testid="resumen-f3-respaldo">
      <h4>Respaldo</h4>
      <div className="rg-resp"><small>Garantía real</small><b data-testid="resumen-respaldo-garantia">{tieneReal ? (g.carga?.texto || g.reales || "Garantía real") : g.items?.length ? `${g.items.length} garantía${g.items.length > 1 ? "s" : ""} · ${usd(g.total)}` : "Sin garantía"}</b></div>
      <div className="rg-resp"><small>Documentos {d.documentos?.anio}</small><b>{d.documentos?.estado || "—"}</b></div>
      <div className="rg-resp"><small>Vencimiento de la línea</small><b>{l.vencimiento ? fecha(l.vencimiento) : "—"}</b></div>
      {alertas.length > 1 && <p className="rg-alerta" data-testid="resumen-respaldo-alerta">{alertas.join(", ").replace(/^./, (c) => c.toUpperCase())}</p>}
    </div>
  );
};

export const Fila3 = ({ d }) => (
  <div className="rs-fila3 rg-fila3">
    <Pagares d={d} /><Cobranza d={d} /><Respaldo d={d} />
  </div>
);
